import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleVs() {
  const article = seoArticles.find((a) => a.slug === "kakobuy-vs-pandabuy-porownanie-2026")!;
  return <ArticleLayout article={article} />;
}